export default {_name:'Text.Decorated',module:'Field',view:'Element/Text/Decorated',options:{color:'textPrimary',md:10}}